import {Graphics, Sprite, Texture} from 'pixi.js';
import {SliderIconType} from './slider/SliderIconType';
import {TextureUrlLoader} from '../../../../utils/TextureUrlLoader';
import {Pivot} from '../../../../utils/Pivot';
import {InstrumentSliderButton} from './slider/InstrumentSliderButton';

export class Slider extends Sprite
{
    public sliderButton: InstrumentSliderButton;
    private back: Graphics;
    private iconSmall: Sprite | undefined;
    private iconBig: Sprite | undefined;
    private current: SliderIconType | undefined;

    constructor() {
        super();

        this.back = new Graphics();
        this.back.beginFill(0xffffff, 1);
        this.back.lineStyle(0, 0, 0);
        this.back.moveTo(0, 10);
        this.back.lineTo(100, 10);
        this.back.lineTo(100, 0);
        this.back.lineTo(0, 10);
        this.back.endFill();
        this.addChild(this.back);

        this.sliderButton = new InstrumentSliderButton();
        this.addChild(this.sliderButton).x = 45;
    }

    async setIconType(value: SliderIconType): Promise<void> {
        if (this.current == value) {
            return;
        }
        if (this.iconSmall) {
            this.removeChild(this.iconSmall);
            this.removeChild(this.iconBig!);
            this.iconSmall.destroy();
            this.iconBig!.destroy();
            this.iconSmall = undefined;
            this.iconBig = undefined;
        }

        let smallTexture: Texture | null = await TextureUrlLoader.load('/images/drawer/' + value + '_s.svg');
        let bigTexture: Texture | null = await TextureUrlLoader.load('/images/drawer/' + value + '_b.svg');
        this.iconSmall = new Sprite(smallTexture!);
        this.iconBig = new Sprite(bigTexture!);
        this.addChild(this.iconSmall).x = -15;
        this.addChild(this.iconBig).x = 120;
        Pivot.centerPivot(this.iconSmall);
        Pivot.centerPivot(this.iconBig);
    }
}
